import View from "../../../Nav/Js/views/bestSalesView";
import components from "./components.js";
components.define("js-bestSales", View);